import { createFilledIcon } from "../createIcon";

export const UserProfileGroupFilledIcon = createFilledIcon(
  <>
    <path d="M9.333 10.667a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667ZM18.666 8.667a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM17.5 17.738c-.134.386.145.834.548.767 2.274-.382 3.285-1.675 3.285-3.212 0-1.837-2.134-3.326-4.766-3.326-.387 0-.763.032-1.123.093-.1.017-.123.15-.038.204 1.25.803 2.352 2.124 2.352 3.889 0 .557-.088 1.09-.259 1.585ZM9.454 20.303c4.73 0 6.788-1.86 6.788-4.154 0-2.294-3.04-4.153-6.788-4.153-3.749 0-6.788 1.86-6.788 4.153 0 2.294 2.057 4.154 6.788 4.154Z" />
  </>,
  "UserProfileGroupFilledIcon"
);
